import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { isWideScreen } from '../../../helpers/browser';
import { lock, unlock } from '../../../helpers/scroll';

import './Select.scss';

export default class Select extends React.Component {
	static maxSelectHeight = __CLIENT__ ? (window.innerHeight * 2) / 3 : 0;

	static propTypes = {
		className: PropTypes.string,
		title: PropTypes.string,
		value: PropTypes.string,
		children: PropTypes.node.isRequired,
		onChange: PropTypes.func.isRequired,
	};

	lostFocus = false;
	unmounted = false;

	state = {
		isExpanded: false,
	};

	handleExpand = () => {
		lock();
		this.setState({ isExpanded: true });
	};

	handleBlur = () => {
		// blur happens too fast, so we want to wait for the activeElement to be set first
		this.lostFocus = true;
		setTimeout(() => {
			if (this.lostFocus && !this.unmounted) {
				unlock();
				this.setState({ isExpanded: false });
			}
		}, 0);
	};

	handleFocus = () => {
		this.lostFocus = false;
	};

	componentWillUnmount() {
		unlock();
		this.unmounted = true;
	}

	render() {
		const { children, onChange, value, title } = this.props;
		const { isExpanded } = this.state;
		if (!children || children.length < 1) {
			return null;
		}

		const flattenedChildren = children.reduce((previousValue, currentValue) => {
			if (Array.isArray(currentValue)) {
				return previousValue.concat(currentValue);
			} else if (typeof currentValue === 'object') {
				previousValue.push(currentValue);
				return previousValue;
			}
		}, []);

		let selectedValue = null;
		if (value) {
			const res = _.find(flattenedChildren, (item) => item.props.value === value);
			if (res) {
				selectedValue = res.props.children;
			}
		}
		if (!selectedValue && flattenedChildren.length) {
			selectedValue = flattenedChildren[0].props.children;
		}

		const classNames = `${this.props.className} select ${isExpanded ? 'select--expanded' : ''}`;

		if (isWideScreen) {
			return (
				<div className={classNames}>
					<div
						className="select--selected-value"
						onBlur={this.handleBlur}
						onClick={isExpanded ? this.handleBlur : this.handleExpand}
						onFocus={this.handleFocus}
						tabIndex="0"
					>
						{selectedValue}
					</div>
					{isExpanded ? (
						<div
							className="select-dropdown styled-scroll"
							style={{ maxHeight: Select.maxSelectHeight }}
						>
							{flattenedChildren.map((child) => (
								<div
									className={`select-item ${child.props.disabled ? 'select-item--disabled' : ''}`}
									data-value={child.props.children}
									key={child.key}
									onBlur={this.handleBlur}
									onClick={() => {
										onChange(child.props.value);
										this.handleBlur();
									}}
									onFocus={this.handleFocus}
									tabIndex="0"
								>
									{child.props.children}
								</div>
							))}
						</div>
					) : null}
				</div>
			);
		} else {
			return (
				<div className={classNames}>
					<select
						className="select-dropdown"
						onChange={(evt) => onChange(evt.target.value)}
						value={value}
						title={title}
					>
						{children}
					</select>
				</div>
			);
		}
	}
}
